/**
 *
 *@author caijing
 *@date 2022/2/28 13:11
 */
import { App } from 'vue';
import 'element-plus/theme-chalk/base.css';
import 'element-plus/theme-chalk/el-loading.css';
import 'element-plus/theme-chalk/el-message.css';
import {
  ElContainer,
  ElHeader,
  ElAside,
  ElMain,
  ElButton,
  ElMenu,
  ElIcon,
  ElRow,
  ElCol,
  ElProgress,
  ElSpace,
  ElTable,
  ElTooltip,
  ElPopover,
  ElEmpty,
  ElSelect,
  ElInput,
  ElPagination,
  ElForm,
  ElCheckbox,
  ElDialog,
  ElDatePicker,
  ElConfigProvider,
  ElTag,
  ElCollapse,
  ElDrawer,
} from 'element-plus/es';
const components = [
  ElContainer,
  ElHeader,
  ElAside,
  ElMain,
  ElButton,
  ElMenu,
  ElIcon,
  ElRow,
  ElCol,
  ElProgress,
  ElSpace,
  ElTable,
  ElTooltip,
  ElPopover,
  ElEmpty,
  ElSelect,
  ElInput,
  ElPagination,
  ElForm,
  ElCheckbox,
  ElDialog,
  ElDatePicker,
  ElConfigProvider,
  ElTag,
  ElCollapse,
  ElDrawer
];

export default function (app: App): void {
  for (const component of components) {
    app.component(component.name, component);
  }
}
